import moment from 'moment';

const ANNOTATION_KEY = "newscorp.com/aws-mini-cost-center";
function isAWSCostAnnotationPresent(entity) {
  return Boolean(entity.metadata.annotations?.[ANNOTATION_KEY]);
}
function parseAnnotation(entity) {
  const annotation = entity.metadata.annotations?.[ANNOTATION_KEY] ?? null;
  if (!annotation) {
    throw new Error(
      `Annotation ${ANNOTATION_KEY} doesn't exist on Entity '${entity.metadata.name}'`
    );
  }
  const [accountId, tagAndValue] = annotation.split(":");
  const [tagKey, tagValue] = tagAndValue.split("=");
  return {
    accountId,
    tagKey,
    tagValue
  };
}
function getPreviousMonthStart(monthsBack = 1) {
  return moment().subtract(monthsBack, "month").startOf("month").format("YYYY-MM-DD");
}
function getPreviousMonthEnd(monthsBack = 1) {
  return moment().subtract(monthsBack, "month").endOf("month").format("YYYY-MM-DD");
}

export { getPreviousMonthEnd, getPreviousMonthStart, isAWSCostAnnotationPresent, parseAnnotation };
//# sourceMappingURL=utils.esm.js.map
